export default __webpack_public_path__ + "static/media/006-storm.93461a46.svg";